import { HttpMethod, requestOptions } from "../../../utils/api/request-options";
import { handleResponse } from "../../../utils/api/response-handler";
import { CalendarSession } from "../model/calendar-session";
import { CalendarSessionOverview } from "../model/calendar-session-overview";

export interface SessionAttendanceEntry {
    actorId: number,
    sessionRole: string,
    status: string,
    comment?: string
}

export interface SessionAttendanceUpdate {
    attendees: SessionAttendanceEntry[]
}

export interface ClassSessionAttendance {
    id: number,
    cohortId: number,
    calendarEventId: string,
    day: string,
    startTime?: string,
    endTime?: string,
    title?: string,
    attendees: SessionAttendanceDTO[]
}

export interface SessionAttendanceDTO {
    id: number,
    sessionId: number,
    actorId: number,
    actorName: string,
    sessionRole: string,
    status: string,
    comment?: string
}

export function getCalendarSessions(cohortId: number, from: string, to: string): Promise<CalendarSessionOverview[]> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/calendar/events/${from}/${to}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<CalendarSessionOverview[]>(response)
        });
}

export function getCalendarSession(cohortId: number, eventId: string): Promise<CalendarSession> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/calendar/events/detail/${encodeURIComponent(eventId)}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<CalendarSession>(response)
        });
}

export function getSessionAttendance(cohortId: number, eventId: string): Promise<ClassSessionAttendance | null> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/calendar/attendance/${encodeURIComponent(eventId)}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<ClassSessionAttendance | null>(response)
        });
}

export function updateSessionAttendance(cohortId: number, eventId: string, data: SessionAttendanceUpdate): Promise<ClassSessionAttendance> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/cohort/${cohortId}/calendar/attendance/${encodeURIComponent(eventId)}`, requestOptions(HttpMethod.POST, data))
        .then(response => {
            return handleResponse<ClassSessionAttendance>(response)
        });
}
